var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMenuCart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#001E3C",
  d: "M21.474 4.215h-4.558c0-.152-.042-1.763-1.295-2.959C14.758.416 13.537 0 12 0S9.253.426 8.379 1.256C7.137 2.462 7.084 4.063 7.084 4.215H2.526A.51.51 0 0 0 2 4.722v17.771c0 .284.232.507.526.507h18.948a.51.51 0 0 0 .526-.507V4.722a.51.51 0 0 0-.526-.507M12 1.003c3.705 0 3.853 2.949 3.863 3.212H8.147c0-.263.148-3.212 3.864-3.212zm8.947 20.994H3.053V5.228h17.894v16.769"
})));
export { SvgMenuCart as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZThlZDI4YWM5NzFhYWM3Nzk5Y2EzMGU1YTYwNzRkMmUuc3ZnIjs=";